module.exports = __webpack_public_path__ + "img/10clubs.3b7552f2.jpg";